const min8LengthRegex = '^.{8,}$';
export default min8LengthRegex;